<se-fe-alert
  seFeDataType="warning">
  Discount
  <se-fe-alert-subheader>
    This is the discount element!
  </se-fe-alert-subheader>
</se-fe-alert>
